import { call, put, select, takeLatest } from "redux-saga/effects";

import { getInitData } from "../actions";

import { getItems } from "../../spItems/actions";
import {
  approversListName,
  collectionsListName,
  departmentsListName,
  linesListName,
  listFields,
  MDWorkstationListName,
  myTaskSettingsListName,
  paramsListName,
  processesListName,
  sectorsListName,
  statusesListName,
  typesListName,
} from "src/api/config";
import { myTaskActionsStatusesListName } from "src/api/config/myTasksActions.config";
import { templatesOWDListName } from "src/api/config/notifications.config";
import {
  myTasks5WayStatusesListName,
  myTasksDepartmentsListName,
  myTasksDeviationReportTriggersListName,
  myTasksKPIListName,
  myTasksLocationsListName,
  myTasksRegionsListName,
  myTasksSDCAListName,
  myTasksTriggersListName,
} from "src/api/config/myTasksLists.config";
import { myTasksIncidentsStatusesListName, myTasksTypeIncidentsListName } from "src/api/config/myTasksInc.config";
import { VPOsettingsListName } from "src/pages/DashboardPage/vpo/api/vpo.config";

function* initDataSaga() {
  const pathname = window.location.pathname;
  const match = pathname.match(/dashboard\/(\d+)/);

  try {
    const arrLists = [
      typesListName,
      sectorsListName,
      processesListName,
      departmentsListName,
      collectionsListName,
      approversListName,
      linesListName,
      statusesListName,
      paramsListName,
      templatesOWDListName,
      myTaskActionsStatusesListName,
      myTasksLocationsListName,
      myTasksDepartmentsListName,
      myTasksRegionsListName,
      myTasksSDCAListName,
      myTasksTriggersListName,
      myTasksDeviationReportTriggersListName,
      myTasksKPIListName,
      myTasks5WayStatusesListName,
      myTasksTypeIncidentsListName,
      myTasksIncidentsStatusesListName,
      myTaskSettingsListName,
      VPOsettingsListName,
      MDWorkstationListName,
    ];
    for (let i = 0; i < arrLists.length; i++) {
      yield put(
        getItems({
          listName: arrLists[i],
          // viewFields: ["ID", "Title", "Code", "Hide", "Key", "ParamsType", "Value", "Color"],
          // rowLimit: 1500,
          sortOrder: { name: Object.keys(listFields[arrLists[i]]).length > 0 && listFields[arrLists[i]].hasOwnProperty('SortColumn') && "SortColumn" || "ID", asc: true },
        }),
      );
      // if (arrLists[i] === collectionsListName) {
      //   yield put(
      //     getItems({
      //       listName: arrLists[i],
      //       // viewFields: ["ID", "Title", "Code", "Hide", "Key", "ParamsType", "Value", "Color"],
      //       // rowLimit: 1500,
      //       // sortOrder: { name: "SortColumn", asc: true },
      //     })
      //   );
      // } else {
      //   yield put(
      //     getItems({
      //       listName: arrLists[i],
      //       filters: { Hide: false },
      //       viewFields: [
      //         "ID",
      //         "Title",
      //         "Code",
      //         "Hide",
      //         "Key",
      //         "ParamsType",
      //         "Value",
      //         "Color",
      //         "TextDeviationReport",
      //         "Text5Way",
      //       ],
      //       rowLimit: 1500,
      //       sortOrder:
      //         ((departmentsListName ||
      //           sectorsListName ||
      //           processesListName ||
      //           typesListName ||
      //           linesListName ||
      //           approversListName) && { name: "SortColumn", asc: true }) ||
      //         null,
      //     })
      //   );
      // }
    }
  } catch (error) {
    console.log(error);
  }
}
export function* initDataWatcher() {
  yield takeLatest(getInitData.toString(), initDataSaga);
}
